module.exports = __webpack_public_path__ + "static/media/VRxProLogo.8f93c54e.png";